import { TopicApiTopicSaveByOfficeRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTopicSaveByOfficeMutation = () =>
  useBaseMutation({
    mutationFn: (req: TopicApiTopicSaveByOfficeRequest, config) =>
      appApiClient.topicApi.topicSaveByOffice(req, config),
  });
